import React from 'react';
import RNToast from 'react-native-toast-message';
import { IconClose } from '../../icons';

interface ToastCloseButtonProps {
  size: number;
  className: string;
}

const ToastCloseButton: React.FC<ToastCloseButtonProps> = ({
  size,
  className,
}) => {
  return (
    <button className={className} onClick={() => RNToast.hide()}>
      <IconClose width={size} height={size} />
    </button>
  );
};

export default ToastCloseButton;
